import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { CrudForm } from "src/app/components/shared/cruds/crud.form";
import { EmpresasDTO } from "src/app/models/empresas.dto";

@Component({
  selector: "app-form-drawer-empresas",
  templateUrl: "./drawer-form.component.html",
})
export class EmpresasDrawerForm
  extends CrudForm<EmpresasDTO>
  implements OnInit
{
  drawerRef: any;
  data?: {
    mode: "create" | "update";
    value: EmpresasDTO;
  };
  constructor(
    public fb: FormBuilder,
  ) {
    super(fb);
  }
  public ngOnInit(): void {
    this.buildForm();
    if (this.data) {
      this.defaults = this.data.value;
      if (this.data.mode === "update") {
        this.setUpdate(this.data.value);
      } else {
        this.setCreate();
      }
    }
  }

  // TODO add validators
    public fromInit(row: EmpresasDTO) {
      this.form.controls["IdEmpresa"].setValue(row?.IdEmpresa);
      this.form.controls["Nombre"].patchValue(row?.Nombre);
      this.form.controls["Direccion"].patchValue(row?.Direccion);
      this.form.controls["Correo"].patchValue(row?.Correo);
      this.form.controls["Telefono"].patchValue(row?.Telefono);
    }

    protected buildForm() {
      this.form = this.fb.group({
        IdEmpresa: [""],
        Nombre: [""],
        Direccion: [""],
        Telefono: [""],
        Correo: ["", Validators.email],
      });
    }

  public saveOver() {
    this.drawerRef.close({
      valid: this.form.invalid,
      data: {
        mode: this.mode,
        value: this.form.value,
      },
    });
  }

}
